<template>
  <y-view :title="showType == 0 ? '新增优惠活动' : showType == 1 ? editPara.activityName : '编辑优惠活动'" :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false" :class="css.query_item" v-if="showType == 1">
      <y-query-item>
        <h3>基本信息</h3>
      </y-query-item>
    </y-query>
    <y-form titleAlign="right" titleWidth="100px" contentWidth="1000px">
      <y-form-item title="销售渠道:" required>
        <k-select v-if="showType != 1" :disabled="showType == 2" :clearable="showType == 0" block
          v-model="editPara.saleChannelCode" :class="css.inputW">
          <k-option v-for="item in channelList" :key="item.code" :selected="editPara.saleChannelCode == item.code"
            :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
        <span v-else>{{ editPara.saleChannelName }}</span>
      </y-form-item>
      <y-form-item title="活动名称:" required>
        <k-input v-if="showType != 1" style="width: 400px;" placeholder="请输入活动名称，不超过20个字。" :clearable="showType == 0"
          maxlength="20" block v-model="editPara.activityName" :disabled="showType == 2"></k-input>
        <span v-else>{{ editPara.activityName }}</span>
      </y-form-item>
      <y-form-item title="活动时间:" required>
        <DatePicker v-if="showType != 1" :editable="false" type="datetimerange" @on-change="changeDate"
          :value="activityTime" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择使用有效期" style="width: 280px;"
          :disabled="showType == 2">
        </DatePicker>
        <span v-else>{{ editPara.startTime }} - {{ editPara.endTime }}</span>
      </y-form-item>
      <y-form-item title="活动状态:" v-if="showType == 1">
        <span>{{ editPara.activityStatusName }}</span>
      </y-form-item>
      <y-form-item title="活动封面:" align="top" required>
        <template v-if="showType != 1">
          <div class="row">
            <y-upload-file-2 fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedImg($event, 1)" :limitSize="10240"></y-upload-file-2>
            <y-image @delete="onDeleteImg($event, 1)" v-dragging="{ list: coverImgList, item: img, group: 'image' }"
              v-for="(img, index) in coverImgList" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（只能上传1张，推荐尺寸1005*531px，每张大小不超过 10M）</div>
        </template>
        <div class="row" v-else>
          <y-image v-dragging="{ list: coverImgList, item: img, group: 'image' }" v-for="(img, index) in coverImgList"
            :key="index" :index="index" :src="img"></y-image>
        </div>
      </y-form-item>
      <y-form-item title="活动详情:" align="top" required>
        <template v-if="showType != 1">
          <div class="row">
            <y-upload-file-2 fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedImg($event, 2)" :limitSize="10240"></y-upload-file-2>
            <y-image @delete="onDeleteImg($event, 2)" v-dragging="{ list: detailImgList, item: img, group: 'image' }"
              v-for="(img, index) in detailImgList" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（只能上传1张，建议宽度1065px，每张大小不超过 10M）</div>
        </template>
        <div class="row" v-else>
          <y-image v-dragging="{ list: detailImgList, item: img, group: 'image' }" v-for="(img, index) in detailImgList"
            :key="index" :index="index" :src="img"></y-image>
        </div>
      </y-form-item>
      <y-form-item title="活动海报:" align="top" required>
        <template v-if="showType != 1">
          <div class="row">
            <y-upload-file-2 fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedImg($event, 3)" :limitSize="10240"></y-upload-file-2>
            <y-image @delete="onDeleteImg($event, 3)" v-dragging="{ list: posterImgList, item: img, group: 'image' }"
              v-for="(img, index) in posterImgList" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（只能上传1张，建议尺寸200*200px，每张大小不超过 10M）</div>
        </template>
        <div class="row" v-else>
          <y-image v-dragging="{ list: posterImgList, item: img, group: 'image' }" v-for="(img, index) in posterImgList"
            :key="index" :index="index" :src="img"></y-image>
        </div>
      </y-form-item>
      <y-form-item title="活动限购:" required>
        <div v-if="showType != 1">
          <div>
            <k-radio v-model="isLimit" :value="false" :disabled="showType == 2" @change="changeToLimit">不限购</k-radio>
          </div>
          <div :class="css.flex" style="width: 230px;">
            <k-radio v-model="isLimit" :value="true" :disabled="showType == 2">用户限购</k-radio>
            <k-input style="width: 140px;" placeholder="请输入" :clearable="showType == 0" type="number" min="1" block
              v-model="editPara.purchaseLimitation" :disabled="showType == 2 || !isLimit"
              @blur="verifyNum('limitNum')"></k-input><span>件</span>
          </div>
        </div>
        <span v-else>{{ editPara.purchaseLimitation > 0 ? '用户限购'+editPara.purchaseLimitation+'件':'不限购' }}</span>
      </y-form-item>
      <!-- 活动门店范围类型（ALL=全部门店，SPECIFIC=指定门店参与，SPECIFIC_NOT=指定门店不参与） -->
      <y-form-item v-if="showType != 1" title="活动门店:" required>
        <div>
          <k-radio v-model="editPara.shopScopeType" value="ALL" :disabled="showType == 2">全部门店</k-radio>
          <k-radio v-model="editPara.shopScopeType" value="SPECIFIC" :disabled="showType == 2">指定门店参与</k-radio>
          <k-radio v-model="editPara.shopScopeType" value="SPECIFIC_NOT" :disabled="showType == 2">指定门店不参与</k-radio>
        </div>
      </y-form-item>
      <y-form-item v-if="showType != 1 && editPara.shopScopeType !== 'ALL'" title="选择门店:" required>
        <div>
          <k-button @click="onDownLoad">下载模板</k-button>
          <y-upload-file acceptType=".xls,.xlsx" :uploadUrl="uploadUrl"
            @uploaded="onUploaded">
            <k-button type="primary">导入</k-button>
          </y-upload-file>
          <k-button style="margin-left: 12px;" @click="onExport">导出</k-button>
        </div>
      </y-form-item>
      <y-form-item v-if="showType != 1 && storeList.length" title="已选门店" align="top">
        <div class="flex">
          <k-input class="mb-1 mr-2" v-model="storeSearchKeyword" placeholder="请输入门店编码或者门店名称" clearable></k-input>
<!--          <y-button icon="k-icon-search">搜索</y-button>-->
<!--          <y-button buttonType="default">重置</y-button>-->
        </div>
        <k-table :data="c_storeList" height="calc(100vh - 420px)" :rightFixedNumber="1" :columns="initColumns()"></k-table>
      </y-form-item>
      <y-form-item v-if="showType != 1" title="活动商品:" required>
        <div :class="css.flex">
          <k-input style="width: 280px;" placeholder="请输入商品货号" :clearable="showType == 0" block
            v-model="editPara.activityGoodsSaleCode" :disabled="showType == 2"></k-input>
          <a @click="addGood">添加</a>
        </div>
      </y-form-item>
      <y-form-item v-if="showType != 1" title="商品批次:" required>
        <k-select2 v-model="editPara.activityBatchNos" :data='batchList' placeholder="请选择批次" :class="css.inputW"
                   key-field='batchNo' text-field='batchNo' search-field='batchNo' layer-width="" layerMinWidthEqual>
        </k-select2>
      </y-form-item>
      <y-form-item v-if="showType != 1 && goodsList.length" title="  ">
        <k-table :data="goodsList" max-height="500px" :rightFixedNumber="1" :columns="initGoodColumns()">
          <template slot="spec" slot-scope="{row}">
            <div :class="css.td_item" v-for="s in row.specs" :key="'spec'+s">{{ s.spec }}</div>
          </template>
          <template slot="salePrice" slot-scope="{row}">
            <div :class="css.td_item" v-for="s in row.specs" :key="'salePrice'+s">
              <div>{{ s.salePrice + '/' + s.allPrice }}</div>
            </div>
          </template>
          <template slot="storeSpecPrice" slot-scope="{row}">
            <div :class="css.td_item" v-for="s in row.specs" :key="'storeSpecPrice'+s">
              <div>{{ s.storeSpecPrice + '/' + s.storePrice }}</div>
            </div>
          </template>
        </k-table>
      </y-form-item>
      <y-form-item v-if="showType == 1" title="  ">
        <y-tab v-model="curType">
          <y-tab-item v-for="(item,index) in typeList" :key="index">
            {{ item.name }}
          </y-tab-item>
        </y-tab>
      </y-form-item>
      <template v-if="showType == 1 && curType == 0 && editPara.shopScopeType !== 'ALL'">
        <y-form-item title="已选门店:" align="top">
          <div class="flex">
            <k-input class="mb-1 mr-2" v-model="storeSearchKeyword" placeholder="请输入门店编码或者门店名称" clearable></k-input>
<!--            <y-button icon="k-icon-search">搜索</y-button>-->
<!--            <y-button buttonType="default">重置</y-button>-->
          </div>
          <k-table :data="c_storeList" :height="$root.tableHeightXX" :rightFixedNumber="1"
            :columns="initColumns()"></k-table>
        </y-form-item>
      </template>
      <template v-if="showType == 1 && curType == 0 && editPara.shopScopeType == 'ALL'">
        <y-form-item title="  ">
          <span>全部门店</span>
        </y-form-item>
      </template>
      <template v-if="showType == 1 && curType == 1">
        <y-form-item title="  ">
          <k-table :data="goodsList" :height="$root.tableHeightXX" :rightFixedNumber="1"
            :columns="initGoodColumns()">
            <template slot="spec" slot-scope="{row}">
              <div :class="css.td_item" v-for="s in row.specs" :key="'spec'+s">{{ s.spec }}</div>
            </template>
            <template slot="salePrice" slot-scope="{row}">
              <div :class="css.td_item" v-for="s in row.specs" :key="'salePrice'+s">
                <div>{{ s.salePrice + '/' + s.allPrice }}</div>
              </div>
            </template>
            <template slot="storeSpecPrice" slot-scope="{row}">
              <div :class="css.td_item" v-for="s in row.specs" :key="'storeSpecPrice'+s">
                <div>{{ s.storeSpecPrice + '/' + s.storePrice }}</div>
              </div>
            </template>
          </k-table>
        </y-form-item>
      </template>
      <template v-if="showType == 1 && curType == 2">
        <y-form-item title="  ">
          <k-table :data="logList" :height="$root.tableHeightXX" :rightFixedNumber="1"
            :columns="initLogColumns()"></k-table>
        </y-form-item>
      </template>
    </y-form>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onCancel(true, false)">取消</k-button>
      <k-button type="primary" @click="onSave" v-if="showType != 1">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_PRICE_ON_SHELF,
  NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_IMPORTSHOPLIST_TEMPLATE,
  NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_IMPORTSHOPLIST,
  NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_DETAIL,
  NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_EDIT,
  NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_CREATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_LISTBYCODES,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_LOG_LIST
} from '@/assets/modules/apiList';
import * as XLSX from 'xlsx';
const initEditPara = () => ({
  saleChannelCode: '', //销售渠道
  activityName: '', //活动名称
  startTime: '', //活动开始时间
  endTime: '', //活动结束时间
  coverUrl: '', //活动封面
  detailImageUrl: '', //活动详情
  posterUrl: '',  //活动海报
  purchaseLimitation: 0, //限购数量 0表示不限购
  shopScopeType: 'ALL', //活动门店范围
  shopCodeList: '', //门店列表
  activityGoodsSaleCode: '', //活动商品货号
  activityBatchNo: '', //活动商品批次
  spec: '', //规格
  specQty: '', //数量
  activityBatchNos: [],//活动批次 多个
});
export default {
  data() {
    return {
      isLoading: false,
      showType: "", // 0 新增  1 查看  2 编辑
      editPara: initEditPara(),
      activityTime: [],
      channelList: [], //销售渠道列表
      coverImgList: [], //活动封面
      detailImgList: [], //活动详情
      posterImgList: [], //活动海报
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      isLimit: false, //是否限购
      storeList: [], //门店列表
      batchList: [], //商品批次列表
      goodsListAll: [], //商品列表(销售渠道 + 商品货号得到的商品列表)
      goodsList2: [], //商品列表(查看)
      logList: [], //操作日志列表
      curType: 0, //当前tab
      typeList: [
        {
          name: "活动门店",
          type: 0,
        },
        {
          name: "活动商品",
          type: 1,
        },
        {
          name: "操作日志",
          type: 2,
        },
      ],
      platPrice: '', //平台价
      salePrice: '', //销售价
      storeSearchKeyword: '',//门店搜索关键词
    }
  },
  watch: {
    // "isLimit": {
    //   handler(newValue) {
    //     if (!newValue) {
    //       this.editPara.purchaseLimitation = 0;
    //     } else {
    //       this.editPara.purchaseLimitation = '';
    //     }
    //   },
    //   immediate: true,
    // },
    "editPara.activityGoodsSaleCode": {
      handler(newValue) {
        if (this.showType != 0) return;
        this.batchList = [];
        this.editPara.activityBatchNo = '';
        this.editPara.activityBatchNos = [];
      }
    },
    "editPara.shopScopeType": {
      handler(newValue) {
        console.log(newValue);
        const typeName = newValue == 'SPECIFIC_NOT' ? "限制门店" : "活动门店";
        this.$set(this.typeList[0], "name", typeName);
        console.log(this.typeList);
      }
    }
  },
  computed: {
    goodsList() {
      return this.goodsListAll.filter(item => this.editPara.activityBatchNos.includes(item.batchNo) );
    },
    c_storeList(){
      return this.storeList.filter(item => {
        if(this.storeSearchKeyword){
          return item.shopCode.toLowerCase().indexOf(this.storeSearchKeyword.toLowerCase())>-1 ||item.shopName.toLowerCase().indexOf(this.storeSearchKeyword.toLowerCase())>-1;
        }else{
          return this.storeList
        }
      });
    }
  },
  methods: {
    changeToLimit(){
      this.editPara.purchaseLimitation = 0;
    },
    initColumns() {
      const columns = [
        {
          name: "序号",
          field: "",
          style: {
            width: 50,
            textAlign: "center",
          },
          customRender: (row, i) => <div>{i + 1}</div>,
        },
        {
          name: "门店编码",
          field: "shopCode",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "门店名称",
          filed: "shopName",
          style: {
            width: 120,
            textAlign: "center"
          },
          customRender: (row) => {
            return row.shopName;
          },
        }
      ];
      if (this.showType == 0 || this.showType == 2) {
        columns.push({
          name: "操作",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row, index) => {
            return (
              <a
                href="javascript:void(0);"
                onClick={() => this.onDelete(row, index)}
              >
                删除
              </a>
            );
          },
        });
      }
      return columns;
    },
    initGoodColumns() {
      return [
        {
          name: "序号",
          field: "",
          style: {
            width: 50,
            textAlign: "center",
          },
          customRender: (row, i) => <div>{i + 1}</div>,
        },
        {
          name: '商品货号',
          field: 'goodsCodeSale',
          style: {
            textAlign: 'center'
          }
        },
        {
          name: '商品名称',
          field: 'goodsNameSale',
          style: {
            textAlign: 'center'
          }
        },
        {
          name: '批次',
          field: 'batchNo',
          style: {
            textAlign: 'center'
          }
        },
        {
          name: "规格",
          field: "spec",
          scopedSlots: 'spec',
          style: {
            width: 120,
            textAlign: "center",
            padding: '0'
          },
        },
        {
          name: (
            <div>
              <div>平台价</div>
              <div>(单价/总价)</div>
            </div>
          ),
          field: "",
          scopedSlots: 'salePrice',
          style: {
            textAlign: "center",
            padding: '0'
          }
        },
        {
          name: (
            <div>
              <div>店铺销售价</div>
              <div>(单价/总价)</div>
            </div>
          ),
          field: "",
          scopedSlots: 'storeSpecPrice',
          style: {
            textAlign: "center",
            padding: '0'
          }
        }
      ]
    },
    initLogColumns() {
      return [
        {
          name: "用户名",
          field: "realName",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "操作时间",
          field: "createTime",
          style: {
            width: 60,
            textAlign: "center",
          },
        },
        {
          name: "操作内容",
          field: "content",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
      ];
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    changeDate(e) {
      this.activityTime = e;
      this.editPara.startTime = e[0];
      this.editPara.endTime = e[1];
    },
    onUploadedImg(data, type) {
      if (type == 1) {
        this.coverImgList = [];
        this.coverImgList.push(data.data[0].url);
        this.editPara.coverUrl = data.data[0].url;
      } else if (type == 2) {
        this.detailImgList = [];
        this.detailImgList.push(data.data[0].url);
        this.editPara.detailImageUrl = data.data[0].url;
      } else if (type == 3) {
        this.posterImgList = [];
        this.posterImgList.push(data.data[0].url);
        this.editPara.posterUrl = data.data[0].url;
      }
    },
    onDeleteImg(e, type) {
      if (type == 1) {
        this.coverImgList.splice(e.index, 1);
      } else if (type == 2) {
        this.detailImgList.splice(e.index, 1);
      } else if (type == 3) {
        this.posterImgList.splice(e.index, 1);
      }
    },
    onDownLoad() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_IMPORTSHOPLIST_TEMPLATE,
        para: {},
      })
        .then((res) => {
          this.isLoading = false;
          window.open(encodeURI(res));
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onUploaded(data) {
      if (this.editPara.shopCodeList && this.editPara.shopCodeList.length > 0) {
        this.$dialog({
          title: "提示",
          content: "如果重新导入，将重新覆盖参与活动的门店范围！",
          ok: () => {
            this.onUploadedShop(data);
          },
        });
      } else {
        this.onUploadedShop(data);
      }
    },
    onUploadedShop(data) {
      this.isLoading = true;
      let { tip } = this.$root;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_IMPORTSHOPLIST,
        para: { excelUrl: data.data[0].url, saleChannelCode: this.editPara.saleChannelCode },
      })
        .then((res) => {
          this.isLoading = false;
          this.storeList = res;
          this.editPara.shopCodeList = res.map(obj => obj.shopCode);
          tip('门店导入成功', 'success');
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onDelete(row, index) {
      this.$dialog({
        title: "提示",
        content: "确认删除当前门店吗？",
        ok: () => {
          this.editPara.shopCodeList=this.editPara.shopCodeList.filter((item)=>{
            return item!==row.shopCode;
          })
          this.storeList = this.storeList.filter(item=>{
            return item.shopCode !== row.shopCode;
          })
        },
      });
    },
    verifyNum(type) {
      let { tip } = this.$root;
      if (!/^[1-9]\d*$/.test(type === 'limitNum' ? this.editPara.purchaseLimitation : this.editPara.specQty)) {
        type === 'limitNum' ? this.editPara.purchaseLimitation = '' : this.editPara.specQty = '';
        return tip('请输入大于0的正整数', 'warning');
      }
    },
    addGood() {
      let { tip } = this.$root;
      if (!this.editPara.saleChannelCode) {
        tip('请选择销售渠道', 'warning');
        return;
      }
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST,
        para: { goodsCodeSale: this.editPara.activityGoodsSaleCode, saleChannelCode: this.editPara.saleChannelCode }
      }).then((res) => {
        if (res.length == 0) {
          tip('请检查商品货号，该商品未上架到销售渠道！', 'warning');
          this.isLoading = false;
          return;
        }
        this.$fetch({
          api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_PRICE_ON_SHELF,
          para: { id: res[0].id }
        }).then((res2) => {
          this.isLoading = false;
          this.goodsListAll = res2.map(item => {
            const specs = item.specs;
            const batchNo = item.batchNo;
            const { goodsNameSale, goodsCodeSale, id } = res[0];
            return { specs, goodsNameSale, goodsCodeSale, id, batchNo };
          });
          this.batchList = this.goodsListAll.map(obj => ({ batchNo: obj.batchNo }));
        }).catch(() => {
          this.isLoading = false;
        });
      }).catch(() => {
        this.isLoading = false;
      });
    },
    calPrice(obj) {
      const index = this.goodsList[0].specs.findIndex(item => item.spec === obj.k);
      this.platPrice = this.goodsList[0].specs[index].salePrice + '/' + this.goodsList[0].specs[index].allPrice;
      this.salePrice = this.goodsList[0].specs[index].storeSpecPrice + '/' + this.goodsList[0].specs[index].storePrice;
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "preferentialManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onSave() {
      this.isLoading = true;
      const { tip } = this.$root;
      if (this.editPara.shopScopeType == 'ALL') {
        delete this.editPara.shopCodeList;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      this.$fetch({
        api: this.showType == 0 ? NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_CREATE : NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_EDIT,
        para,
      }).then((res) => {
        this.isLoading = false;
        tip('保存成功', 'success');
        this.onCancel(true, true);
      }).catch(() => {
        this.isLoading = false;
      });
    },
    getActivityDetail(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_DETAIL,
        para: { id },
      }).then((res) => {
        this.isLoading = false;
        this.editPara = res;
        this.isLimit = res.purchaseLimitation > 0;
        this.activityTime = [res.startTime, res.endTime];
        this.coverImgList = [res.coverUrl];
        this.detailImgList = [res.detailImageUrl];
        this.posterImgList = [res.posterUrl];
        if (res.shopCodeList && res.shopCodeList.length > 0) {
          this.$fetch({
            api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_LISTBYCODES,
            para: res.shopCodeList,
          }).then((res2) => {
            this.storeList = res2;
          }).catch(() => {
            this.isLoading = false;
          });
        }
        this.$fetch({
          api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST,
          para: { goodsCodeSale: this.editPara.activityGoodsSaleCode, saleChannelCode: this.editPara.saleChannelCode }
        }).then((res) => {
          if (res.length == 0) {
            tip('请检查商品货号，该商品未上架到销售渠道！');
            this.isLoading = false;
            return;
          }
          this.$fetch({
            api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_PRICE_ON_SHELF,
            para: { id: res[0].id }
          }).then((res2) => {
            this.isLoading = false;
            this.goodsListAll = res2.map(item => {
              const specs = item.specs;
              const batchNo = item.batchNo;
              const { goodsNameSale, goodsCodeSale, id } = res[0];
              return { specs, goodsNameSale, goodsCodeSale, id, batchNo };
            });
            this.batchList = this.goodsListAll.map(obj => ({ batchNo: obj.batchNo }));
          }).catch(() => {
            this.isLoading = false;
          });
        }).catch(() => {
          this.isLoading = false;
        });
        if (this.showType == 1) {
          this.$fetch({
            api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_LOG_LIST,
            para: { resourceCode: id, resourceName: 'PROMOTIONAL_ACTIVITY' }
          }).then((res) => {
            this.logList = res;
          }).catch(() => {
            this.isLoading = false;
          });
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    //导出门店
    onExport(){
      let rows=this.storeList.map((item,index)=>{
        return {
          '序号':index+1,
          '门店编码':item.shopCode,
          '门店名称':item.shopName
        }
      })
      let worksheet = XLSX.utils.json_to_sheet(rows);
      let workbook = XLSX.utils.book_new();
      for (let key in worksheet){
        if(key.indexOf('!')<0&&worksheet[key].v){
          worksheet[key].s={
            alignment:{
              horizontal:'center',
              vertical:'center',
              wrapText:true
            }
          }
        }
      }
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      /* fix headers */
      // XLSX.utils.sheet_add_aoa(worksheet, [["序号", "门店编码","门店名称"]], { origin: "A1" });
      /* calculate column width */
      worksheet["!cols"] = [ { wch: 10 },{ wch: 20 },{ wch: 20 } ];
      /* create an XLSX file and try to save to Presidents.xlsx */
      XLSX.writeFile(workbook, "门店列表.xlsx", { compression: true });
    }
  },
  created() {
    const { id, showType } = this.$route.query;
    this.showType = showType;
    this.editPara = initEditPara();
    this.activityTime = [];
    this.coverImgList = [];
    this.detailImgList = [];
    this.posterImgList = [];
    this.storeList = [];
    this.getChannelList();
    if (showType != 0) {
      this.getActivityDetail(id);
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, showType } = to.query;
    this.showType = showType;
    this.editPara = initEditPara();
    this.activityTime = [];
    this.coverImgList = [];
    this.detailImgList = [];
    this.posterImgList = [];
    this.storeList = [];
    if (showType != 0) {
      this.getActivityDetail(id);
    }
    next();
  }
}
</script>

<style lang="postcss" module="css">
.box {
  display: inline-block;
}

.tr {
  height: 39px;
  line-height: 39px;
  border-bottom: 1px solid #eaecf0;
}

.box p:last-of-type {
  border-bottom: 0px solid #eaecf0;
}

.flex {
  display: flex;
  width: 320px;
  justify-content: space-between;
  align-items: center;
}

.inputNumberW {
  width: 80px !important;
}

.inputW {
  width: 400px !important;
}

.select {
  width: 120px !important;
}

.tableW {
  width: 600px;
  padding-left: 60px;
  margin: 10px 0px 20px;
}

.textarea {
  width: 400px !important;
  height: 200px;
  margin-bottom: 30px;

  & :global(.k-textarea) {
    height: 200px !important;
    resize: none;
  }
}

.desc {
  color: #999;
}

.goods_table {
  & :global(.k-tablebox) {
    overflow: visible !important;
  }
}

.query_item {
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid rgb(227, 227, 227);
  margin-bottom: 0 !important;
}
.td_item{
  height: 35px;
  line-height: 35px;
  border-bottom: 1px solid #eaecf0;
  &:last-child{
    border: none;
  }
}
</style>
